"use strict";
/**
 * Profile score types and utilities.
 *
 * The decision-based scoring paradigm produces three decisions (REACH_OUT / MAYBE / SKIP)
 * stored as numeric scores (5 / 3 / 1) in profile_scores with
 * generationInfo.paradigm = 'scoring-brief'.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecision = exports.fivePointScore = exports.isSparkScore = exports.isDecisionScore = exports.decisionToScore = void 0;
const SCORE_REACH_OUT = 5;
const SCORE_MAYBE = 3;
const SCORE_SKIP = 1;
function decisionToScore(decision) {
    if (decision === 'REACH_OUT')
        return SCORE_REACH_OUT;
    if (decision === 'MAYBE')
        return SCORE_MAYBE;
    return SCORE_SKIP;
}
exports.decisionToScore = decisionToScore;
function isDecisionScore(generationInfo) {
    return (generationInfo === null || generationInfo === void 0 ? void 0 : generationInfo.paradigm) === 'scoring-brief';
}
exports.isDecisionScore = isDecisionScore;
function isSparkScore(generationInfo) {
    return (generationInfo === null || generationInfo === void 0 ? void 0 : generationInfo.paradigm) === 'spark';
}
exports.isSparkScore = isSparkScore;
function fivePointScore(score) {
    const maxScore = 5;
    return isSparkScore(score.generationInfo) ? score.score * maxScore : score.score;
}
exports.fivePointScore = fivePointScore;
function scoreToDecision(score) {
    if (score === SCORE_REACH_OUT)
        return 'REACH_OUT';
    if (score === SCORE_MAYBE)
        return 'MAYBE';
    if (score === SCORE_SKIP)
        return 'SKIP';
    return null;
}
function getDecision(generationInfo, score) {
    var _a;
    if (!isDecisionScore(generationInfo))
        return null;
    return (_a = generationInfo === null || generationInfo === void 0 ? void 0 : generationInfo.decision) !== null && _a !== void 0 ? _a : scoreToDecision(score);
}
exports.getDecision = getDecision;
//# sourceMappingURL=profile-score.js.map